import * as React from 'react';
import { Link } from 'react-router-dom';
import { Card, Dropdown, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap'; 
import * as models from '../../../models';
import services from 'services';
import dateFormat from 'dateformat';
import NumberFormat from 'react-number-format';
import utils from '../../../utils';
import infoIcon from '../../../assets/images/Blue/info-circle.svg'; 
import downloadIcon from '../../../assets/images/Blue/download.svg';
import SingleActionButton from 'components/common/SingleActionButton'; 
import { AD_Invoice_Selector } from '../../../models/enums'; 
import { ConsoleSqlOutlined } from '@ant-design/icons';

interface Props {
    invoices: models.AdjusterInvoice[]
    invoiceSelector: AD_Invoice_Selector;     
    isLoading: boolean; 
    handlePageSizeSelect: (v: AD_Invoice_Selector) => void; 
    download: () => void; 
}

interface State {        
}

class AdjusterInvoices extends React.Component<Props, State> {
    public state = {
    };        

    public downloadFile = async (id: number) => {
        const response = await services.api.financials.getInvoiceAttachment(id);         
        if(response) {            
            utils.filehelpers.openFileNewTab(response.data); 
        }
    }

    public render() {
        const { invoices, invoiceSelector } = this.props;       
   
        return (
            <Card className="claim-card">                
                <Card.Title style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        Most Recent Invoices
                        <OverlayTrigger
                            key="overlayTrigger"
                            placement="top"                                                            
                            overlay={
                                <Tooltip className="my-tooltip2" id="af-tooltip">
                                    <span style={{fontWeight: "bolder"}}>Gross Loss: </span>Gross Loss from Invoice<br/>
                                    <span style={{fontWeight: "bolder"}}>Total Fees: </span>Invoice Grand Total (includes sales tax where applicable).<br/>
                                    <span style={{fontWeight: "bolder"}}>Fees Paid: </span>Total amt remitted by carrier for Fee.<br/>
                                    <span style={{fontWeight: "bolder"}}>Total Outstanding: </span>Fee Total - Fees Paid (remaining carrier balance)<br/>
                                    <span style={{fontWeight: "bolder"}}>Adj Total: </span>Fee Amt * Adjuster % (how much belongs to adjuster, regardless of collection or payroll)<br/>
                                    <span style={{fontWeight: "bolder"}}>Adj Balance: </span>Total Eligible Amt - Total Payrolled<br/>
                                    <span style={{fontWeight: "bolder"}}>Advanced Amt: </span>Total payed to adjuster prior to collection from carrier.<br/>
                                    <span style={{fontWeight: "bolder"}}>Total Payrolled: </span>Total amt payed out to adjuster.<br/>
                                </Tooltip>
                            }
                        >
                            <img className="info-icon" src={infoIcon}/>
                        </OverlayTrigger>
                        <div>
                            <div style={{
                                display: "flex", 
                                flexDirection: "row", 
                                marginTop: "0",                                                                
                                }} className='inv-pager'>                                    
                                <Dropdown className='' style={{}}>
                                    <Dropdown.Toggle style={{paddingLeft: "1em", paddingRight: "1em", backgroundColor: "#2259a1"}}>{invoiceSelector}
                                        <Dropdown.Menu>
                                            {Object.values(AD_Invoice_Selector).map((choice, i) => (
                                                <Dropdown.Item 
                                                    key={i} 
                                                    onClick={() => this.props.handlePageSizeSelect(choice)}
                                                    >{choice}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown.Toggle>
                                </Dropdown>    
                                {this.props.isLoading && 
                                    <span style={{marginLeft: ".5em", marginTop: ".25em"}}>&nbsp;&nbsp;<Spinner animation="grow" role="status" variant="primary" size='sm'/></span>
                                }
                            </div>  
                        </div>
                    </div>
                    <SingleActionButton
                        action="Export"
                        title="Invoices"
                        img={downloadIcon}
                        onClick={() => this.props.download()}
                        disabled={invoices.length == 0}
                    />
                </Card.Title>                
                {invoices.length == 0 && <div>0 results found</div>}
                {invoices[0] &&
                <Table striped>
                    <thead>
                        <tr>
                            <th>Company</th>                            
                            <th>Claim #</th>
                            <th>Insured</th>
                            <th>Invoice #</th>
                            <th>Invoice Dt</th>
                            <th>Gross Loss</th>
                            <th>Total Fees</th>
                            <th>Total Paid</th>
                            <th>Total Outstanding</th>
                            <th>Adj Total</th>
                            <th>Adj Balance</th>
                            <th>Advanced Amt</th>
                            <th>Total Payrolled</th>
                        </tr>
                    </thead>
                    <tbody>
                    {invoices.map((x: models.AdjusterInvoice, i: number) => (
                        <tr key={i}>
                            <td>{x.insuranceCompany}</td>
                            <td><Link to={"/claim/" + x.claimId}>{x.claimNumber}</Link></td>
                            <td>{x.insured}</td>
                            <td 
                                style={{cursor: (x.hasPdf ? 'pointer' : 'auto')}}
                                className={x.hasPdf ? "value-link" : ""}
                                onClick={() => this.downloadFile(x.invoiceId)}>{x.invoiceNumber}
                            </td>
                            <td>{dateFormat(x.invoiceDt, 'mm/dd/yyyy')}</td>
                            <td><NumberFormat value={x.grossLoss?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                            <td><NumberFormat value={x.totalFees?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                            <td><NumberFormat value={x.totalPaid?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                            <td><NumberFormat value={x.totalOutstanding?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>                            
                            <td><NumberFormat value={x.adjusterTotal?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>                            
                            <td><NumberFormat value={x.adjusterBalance?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>                            
                            <td><NumberFormat value={x.advancedPayrolled?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>                            
                            <td><NumberFormat value={x.totalPayrolled?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>                            
                        </tr>
                    ))}
                    </tbody>
                </Table>
            }                
            </Card>
        );
    }
}

export default AdjusterInvoices;